export enum BioCheckErrorCode {
  InternalError = 'INTERNAL_ERROR',
  UserNotActive = 'USER_NOT_ACTIVE',
  Expired = 'EXPIRED',
  InvalidMedia = 'INVALID_MEDIA',
  TooFewFeatures = 'TOO_FEW_FEATURES',
  ObjectNotFound = 'OBJECT_NOT_FOUND',
  TooFewObjects = 'TOO_FEW_OBJECTS',
  BadContrast = 'BAD_CONTRAST',
  BadDynamicRange = 'BAD_DYNAMIC_RANGE',
  BadExposure = 'BAD_EXPOSURE',
  BadLighting = 'BAD_LIGHTING',
  BadObject = 'BAD_OBJECT',
  BadPose = 'BAD_POSE',
  BadSharpness = 'BAD_SHARPNESS',
  Occlusion = 'OCCLUSION',
  TooNoisy = 'TOO_NOISY',
  InvalidSampleResolution = 'INVALID_SAMPLE_RESOLUTION',
  NotEnoughAudio = 'NOT_ENOUGH_AUDIO',
  AudioTooShort = 'AUDIO_TOO_SHORT',
  AudioTooSoft = 'AUDIO_TOO_SOFT',
  AudioTooLoud = 'AUDIO_TOO_LOUD',
  AudioTooNoisy = 'AUDIO_TOO_NOISY',
  MultiSpeakersDetected = 'MULTI_SPEAKERS_DETECTED',
  WrongPassphrase = 'WRONG_PASSPHRASE',
  Unknown = 'UNKNOWN',
}
